module.exports = __webpack_public_path__ + "static/media/44_Ilja_D_webfinal.4d6eee39.jpg";